import {
  ListGeoEndpointsFilter,
  DeleteJobsRequest,
  GeoInferenceEndpoint,
} from "../../appstore/models";

// import { S3 } from "@aws-sdk/client-s3";
// import { APIGatewayClient } from "@aws-sdk/client-api-gateway";
// import apigClientFactory from "../../common/api-gateway-client/apigClient";
// import { getCredentials, getAwsRegion } from "../../common/credentials";

/*
export const getJobsApi = async () => {
  const credentials = getCredentials();
  const awsRegion = getAwsRegion();
  
  //const s3Client = new S3({
  //  region: awsRegion,
  //  credentials,
  //});
  //s3Client
  //  .listObjects({ Bucket: "oversightml-test-299226988948-us-east-1" })
  //  .then((x) => console.log("yeee", x));

  try {
  } catch (e) {}
  const apiGateayClient = new APIGatewayClient({
    region: awsRegion,
    credentials,
  });
  const client = apigClientFactory.newClient({
    invokeUrl: process.env.REACT_APP_API_GATEWAY_ENDPOINT,
    region: process.env.REACT_APP_AWS_DEFAULT_REGION,
    accessKey: credentials.accessKeyId,
    secretKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken,
  });
  var pathParams = {
    jobArn:
      "arn:aws:oversightml:us-east-1:299226988948:ipj/Job-2021-05-21T13:23:54.121858",
  };
  // Template syntax follows url-template https://www.npmjs.com/package/url-template
  var pathTemplate = "/processing/geo-campaigns/{jobArn}";
  var method = "GET";
  var additionalParams = {};
  var body = {
    //This is where you define the body of the request
  };

  client
    .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
    .then(function (result) {
      console.log("APIG SUCCESS!!! ", result);
      //This is where you would put a success callback
    })
    .catch(function (result) {
      console.log("APIG ERROR!!! ", result);
      //This is where you would put an error callback
    });
  // apiGateayClient.send();
};
*/

export const getGeoEndpoints = async (
  allGeoEndpoints: GeoInferenceEndpoint[],
  request: ListGeoEndpointsFilter
) => {
  // To be modified with "await fetch(url, request)"
  let filteredJobs = allGeoEndpoints.filter((job) => {
    const nameMatch = request.Filter.name
      ? job.name.toLowerCase().indexOf(request.Filter.name.toLowerCase()) > -1
      : true;

    return nameMatch;
  });

  return {
    FeatureDetectionJobPropertiesList: filteredJobs.slice(
      (request.PageNumber - 1) * request.MaxResults,
      request.PageNumber * request.MaxResults
    ),
    NextToken: "NextTokenHere",
    TotalCount: filteredJobs.length,
  };
};

export const deleteJobs = (request: DeleteJobsRequest) => {
  /*
  let jobsCopy = JOBS.filter((job) => {
    return request.JobIDs.indexOf(job.id) === -1;
  });
  JOBS = [...jobsCopy];
  */
  return {
    status: "ok",
    message: "Deleted successfully",
  };
};
